var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotwArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#000",
    fillOpacity: 0.65,
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 12790 c-195 -41 -335 -242 -309 -445 6 -51 383 -811 3040 -6125 2901 -5801 3036 -6069 3082 -6110 61 -54 157 -99 231 -106 118 -13 258 40 334 125 31 35 771 1508 3070 6106 2924 5849 3029 6062 3035 6126 15 173 -76 326 -237 403 -59 27 -74 30 -160 30 -79 -1 -104 -5 -150 -26 -30 -13 -1359 -894 -2953 -1956 l-2897 -1932 -2897 1932 c-1594 1062 -2923 1942 -2953 1956 -61 27 -168 37 -236 22z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotwArrow);
export default __webpack_public_path__ + "static/media/botw-arrow.8a44163e0a90085a864bed3987fa926b.svg";
export { ForwardRef as ReactComponent };